import { render } from "./docFilters4.vue?vue&type=template&id=3260cbb4"
import script from "./docFilters4.vue?vue&type=script&lang=js"
export * from "./docFilters4.vue?vue&type=script&lang=js"

import "./docFilters4.vue?vue&type=style&index=0&id=3260cbb4&lang=scss"

import exportComponent from "/home/ivan/Downloads/3(1)/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__